import Rails from "@rails/ujs"

import "./jquery_global"

import './mypage/js/header'

Rails.start()

$('#step-open').on('click', function() {
  return false;
});
